import { subscribe } from '@/hooks/use-event-stream'
import { useTabNotificationsStore } from '@/stores/tab-notifications.store'
import { useEffect } from 'react'

export function useTabNotificationEvents() {
  useEffect(() => {
    const unsubscribe = subscribe((event) => {
      if (
        event.type === 'job_matching_status_changed' &&
        (event.data as { status?: string })?.status === 'completed'
      ) {
        useTabNotificationsStore.getState().setJobsNotification(true)
      }
      if (
        event.type === 'job_search_status_changed' &&
        (event.data as { status?: string })?.status === 'completed'
      ) {
        useTabNotificationsStore.getState().setJobsNotification(true)
      }

      if (
        event.type === 'learning_topic_status_changed' &&
        (event.data as { status?: string })?.status === 'ready'
      ) {
        useTabNotificationsStore.getState().setSkillsNotification(true)
      }
    })

    return unsubscribe
  }, [])
}
